import utils from '@/utils/unitNumber';
import moment from 'moment'

export const goodsTableColums = [
  {
      title: '货品',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 200,
      customRender: (value, row) => {
      return {
          children: value,
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '温区',
      dataIndex: 'temperatureZone',
      key: 'temperatureZone',
      width: 100,
      customRender: (value, row) => {
      return {
          children: value,
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '指定批次',
      dataIndex: 'stockBatch',
      key: 'stockBatch',
      width: 100
  },
  {
      title: '计划量',
      dataIndex: 'plan',
      key: 'plan',
      scopedSlots: { customRender: 'plan' },
      width: 250,
      customRender: (value, row) => {
      return {
          children: (
              <div>
                <p>共{row.planAmount}件</p>
                <p>共{row.planWeight}kg/{row.planVolume}M³</p>
              </div>
            ),
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '出库量',
      dataIndex: 'deliver',
      key: 'deliver',
      scopedSlots: { customRender: 'deliver' },
      width: 250,
      customRender: (value, row) => {
      return {
          children: (
              <div>
                <p>共{row.deliver_finish_sum}件</p>
                <p>共{row.deliver_finish_weight}kg/{row.deliver_finish_volume}M³</p>
              </div>
            ),
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '签收量',
      dataIndex: 'sign',
      key: 'sign',
      scopedSlots: { customRender: 'sign' },
      width: 250,
      customRender: (value, row) => {
      return {
          children: (
              <div>
                <p>共{row.sign_sum}件</p>
                <p>共{row.sign_weight}kg/{row.sign_volume}M³</p>
              </div>
            ),
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '拒收量',
      dataIndex: 'refuse',
      width: 250,
      customRender: (value, row) => {
        return {
            children: (
              <div>
                <p>共{row.refuse_sum}件</p>
                <p>共{row.refuse_weight}kg/{row.refuse_volume}M³</p>
              </div>
            ),
            attrs: {
                rowSpan: row.rowSpan,
            },
        };
      },
  },
  ]
export const goodsTableColumsUN = [
  {
      title: '货品',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 200,
      customRender: (value, row) => {
      return {
          children: value,
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '温区',
      dataIndex: 'temperatureZone',
      key: 'temperatureZone',
      width: 100,
      customRender: (value, row) => {
      return {
          children: value,
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '指定批次',
      dataIndex: 'stockBatch',
      key: 'stockBatch',
      width: 100
  },
  {
      title: '计划量',
      dataIndex: 'plan',
      key: 'plan',
      scopedSlots: { customRender: 'plan' },
      width: 250,
      customRender: (value, row) => {
      return {
          children: (
          <div>
            <p>共{row.planAmount}件</p>
            <p>共{row.planWeight}kg/{row.planVolume}M³</p>
          </div>
        ),
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '出库量',
      dataIndex: 'deliver',
      key: 'deliver',
      scopedSlots: { customRender: 'deliver' },
      width: 250,
      customRender: (value, row) => {
      return {
          children: (
          <div>
            <p>共{row.deliver_finish_sum}件</p>
            <p>共{row.deliver_finish_weight}kg/{row.deliver_finish_volume}M³</p>
          </div>
        ),
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '入库量',
      dataIndex: 'store',
      key: 'store',
      scopedSlots: { customRender: 'store' },
      width: 250,
      customRender: (value, row) => {
      return {
          children: (
              <div>
                <p>共{row.store_finish_sum}件</p>
                <p>共{row.store_finish_weight}kg/{row.store_finish_volume}M³</p>
              </div>
            ),
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
  {
      title: '签收量',
      dataIndex: 'sign',
      key: 'sign',
      scopedSlots: { customRender: 'sign' },
      width: 250,
      customRender: (value, row) => {
      return {
          children: 
            (
              <div>
                <p>共{row.sign_sum}件</p>
                <p>共{row.sign_weight}kg/{row.sign_volume}M³</p>
              </div>
            ),
          attrs: {
              rowSpan: row.rowSpan,
          },
      };
      },
  },
]

export const orderAmount = [
    {
      title: '类型',
      dataIndex: 'costType',
      key: 'costType',
    },
    {
      title: '费目',
      dataIndex: 'subType',
      key: 'subType',
    },
    {
      title: '金额（元）',
      dataIndex: 'cost',
      key: 'cost',
    },
]

export const nowwaGoodsTable = [
  {
    label: '序号',
    type: 'index',
    width: 70,
  },
  {
    label: '明细ID',
    prop: 'id',
    width: 180,
  },
  {
    title: '签收量',
    dataIndex: 'sign',
    key: 'sign',
    scopedSlots: { customRender: 'sign' },
    width: 250,
  },
  {
    title: '签收量',
    dataIndex: 'sign',
    key: 'sign',
    scopedSlots: { customRender: 'sign' },
    width: 250,
  },
  {
    title: '签收量',
    dataIndex: 'sign',
    key: 'sign',
    scopedSlots: { customRender: 'sign' },
    width: 250,
  },
]
const numberFotmat = (current, rowData) => {
  let result = '';
  if (current) {
    result = utils.calculate({
      bigUnit: rowData.bigUnit || '',
      smallUnit: rowData.smallUnit || '',
      smallUnitNumber: current,
      bigUnitNumber: 0,
      conversionRate: rowData.conversionRate,
    }).txt;
  } else {
    result = current;
  }

  return result;
};
function filterLabel(val, arr) {
  const filterArr = arr.find((item) => item.value === val);
  return filterArr ? filterArr.label : '';
}
export const URGENT = [
  {
    label: '是',
    value: true,
  },
  {
    label: '否',
    value: false,
  },
];
export const URGENT_ENUM = URGENT
  .reduce((total, item) => ({ ...total, [item.value]: item.label }), {});

export const TEMPERATURE_LAYER_CODE_NEW = [
  { value: 'NORMAL', label: '常温' },
  { value: 'REFRIGERATE', label: '冷藏' },
  { value: 'COLD', label: '冷冻' },
  { value: 'CONSTANT', label: '恒温' },
];
export const TEMPERATURE_LAYER_CODE_NEW_ENUM = TEMPERATURE_LAYER_CODE_NEW
  .reduce((total, item) => ({ ...total, [item.value]: item.label }), {});
export const TABLECOLUMN = (type, GOODS_QUALITY) => {
  const GOODS_BEFOR_COLUMN = [
    {
      label: '明细ID',
      prop: 'id',
      width: 180,
    }];
  const GOODS_AFTER_COLUMN = [{
    label: '验收数量',
    prop: 'acceptanceNum',
    width: 180,
    formatter: (row) => numberFotmat(row.acceptanceNum, row),

  }, {
    label: '上架数量',
    prop: 'upperShelfNum',
    width: 180,
    formatter: (row) => numberFotmat(row.upperShelfNum, row),

  }, {
    label: '是否抄码',
    prop: 'copyCode',
    width: 180,
    formatter: (row) => URGENT_ENUM[row.copyCode],

  }, {
    label: '是否已分配库位',
    prop: 'assignedLocation',
    width: 180,
    formatter: (row) => URGENT_ENUM[row.assignedLocation],

  }, {
    label: '备注',
    prop: 'ext.remark',
    width: 180,

  }];
  const GOODS_CENTER_COLUMN = [{
    label: '货主货品编码',
    prop: 'shipperGoodsCode',
    width: 180,
  }, {
    label: '商品名称',
    prop: 'goodsName',
    width: 180,
  }, {
    label: '规格',
    prop: 'spec',
    width: 180,
  }, {
    label: '温层',
    prop: 'temperatureLayer',
    width: 180,
    formatter: ({ temperatureLayer }) => TEMPERATURE_LAYER_CODE_NEW_ENUM[temperatureLayer],
  }, {
    label: '保质期(天)',
    prop: 'shelfLife',
    width: 180,
  }, {
    label: '是否越库',
    prop: 'crossDocking',
    width: 180,
    formatter: ({ crossDocking }) => (crossDocking ? '是' : '否'),
  }, {
    label: '批属性(预约)',
    prop: 'batchAttr',
    width: 180,
    formatter: ({ batchAttr }) => batchAttr.map((item) => item.attrName).join(','),

  },
  {
    label: '货品质量',
    prop: 'quality',
    width: 180,
    formatter: ({ quality }) => filterLabel(quality, GOODS_QUALITY),
  }, {
    label: '换算关系',
    prop: 'conversionRate',

  }, {
    label: '默认单位',
    prop: 'defaultUnit',
  }, {
    label: '预约数量(默认单位)',
    prop: 'defaultUnitBookingNum',
    width: 180,
  }, {
    label: '预约数量',
    prop: 'bookingNum',
    width: 180,
    formatter: (row) => numberFotmat(row.bookingNum, row),

  }];
  const TABLECOLUMN_INSIDE = {
    // 货品明细
    goods: [...GOODS_BEFOR_COLUMN, ...GOODS_CENTER_COLUMN, ...GOODS_AFTER_COLUMN],
    // 验收详情
    acceptanceDetails: [{
      label: '货主货品编码',
      prop: 'shipperGoodsCode',
      width: 180,
    }, {
      label: '商品名称',
      prop: 'goodsName',
      width: 180,
    }, {
      label: '批属性(预约)',
      prop: 'batchFields',
      width: 180,
      formatter: ({ batchFields }) => (batchFields ? batchFields.map((item) => item.fieldName).join(',') : ''),
    }, {
      label: '入库单明细ID',
      prop: 'taskId',
      width: 180,
    }, {
      label: '换算关系',
      prop: 'conversionRate',
      width: 180,
    }, {
      label: '默认单位',
      prop: 'defaultUnit',
    }, {
      label: '验收数量(默认单位)',
      prop: 'defaultUnitAcceptanceNum',
      width: 180,
    }, {
      label: '验收数量',
      prop: 'acceptanceValue',
      width: 180,
      formatter: (row) => numberFotmat(row.acceptanceValue, row),
    }, {
      label: '批次号',
      prop: 'batchNo',
      width: 180,
    }, {
      label: '生产日期',
      prop: 'productDate',
      width: 180,
      formatter: ({ productDate }) => productDate?moment(productDate).format('YYYY-MM-DD HH:mm:ss'):'' ,

    }, {
      label: '验收容器',
      prop: 'containerCode',
      width: 180,

    }, {
      label: '货品质量',
      prop: 'quality',
      width: 180,
      formatter: ({ quality }) => filterLabel(quality, GOODS_QUALITY),
    }, {
      label: '验收人',
      prop: 'operatorStaffName',
      width: 180,

    }, {
      label: '验收时间',
      prop: 'operationTime',
      width: 180,
      formatter: ({ operationTime }) =>moment(operationTime || '').format('YYYY-MM-DD HH:mm:ss'),
    }, {
      label: '操作',
      prop: 'action',
      fixed: 'right',
      width: 160,
    },
    ],
    // 上架详情
    upperShelfDetail: [{
      label: '货主货品编码',
      prop: 'shipperGoodsCode',
      width: 180,
    }, {
      label: '商品名称',
      prop: 'goodsName',
      width: 180,
    }, {
      label: '入库单明细ID',
      prop: 'taskId',
      width: 180,
    }, {
      label: '换算关系',
      prop: 'conversionRate',
      width: 180,
    }, {
      label: '批次号',
      prop: 'batchNo',
      width: 180,
    }, {
      label: '生产日期',
      prop: 'productDate',
      width: 180,
      formatter: ({ productDate }) =>moment(productDate || '').format('YYYY-MM-DD HH:mm:ss') ,
    }, {
      label: '上架库位',
      prop: 'onloadStorehouseCode',
      width: 180,

    }, {
      label: '上架数量',
      prop: 'upperShelfNum',
      width: 180,
      formatter: (row) => numberFotmat(row.upperShelfNum, row),

    }, {
      label: '上架容器',
      prop: 'containerCode',
      width: 180,

    },
    {
      label: '货品质量',
      prop: 'goodsQuality',
      width: 180,
      formatter: ({ goodsQuality }) => filterLabel(goodsQuality, GOODS_QUALITY),
    }, {
      label: '上架人',
      prop: 'operatorStaffName',
      width: 180,

    }, {
      label: '上架时间',
      prop: 'operationTime',
      width: 180,
      formatter: ({ operationTime }) =>moment(operationTime || '').format('YYYY-MM-DD HH:mm:ss'),
    },
    ],
  };
  return TABLECOLUMN_INSIDE[type] || [];
};